module.exports = () => {

  const parents = document.querySelectorAll('.menu-item-has-children');

  parents.forEach((parent) => {

    const parentLink = parent.querySelector('a');
    
    parentLink.innerHTML += ' <i class="fa fa-caret-right"></i>';

    let keepOpen;

    parent.addEventListener('mouseenter', () => {
      clearTimeout(keepOpen);
      if (!parent.classList.contains('open')) {
        parent.classList.add('open');
      }
    });

    parent.addEventListener('mouseleave', () => {
      clearTimeout(keepOpen);
      keepOpen = setTimeout(() => {
        if (parent.classList.contains('open')) {
          parent.classList.remove('open');
        }
      }, 500);
    });

    const childMenu = parent.querySelector('.sub-menu');

    childMenu.addEventListener('mouseenter', () => {
      clearTimeout(keepOpen);

    });

  });

}
